import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export default function SimpleModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.content.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.content.body}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Schließen</Button>
            </Modal.Footer>
        </Modal>
    )
}

